<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-1 pt-2 w-100" [ngClass.md]="'d-flex flex-wrap'">
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'col-6 pl-0 mb-1'" [ngClass.sm]="'mb-075'">
          <label class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filterAssets(); changeQueryParams()" />
          </label>
        </div>
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'col-6 pr-0 mb-1'" [ngClass.sm]="'mb-075'">
          <ng-select
            [ngClass.xl]="'ml-1 my-width'"
            [(ngModel)]="filter_assigned"
            [closeOnSelect]="true"
            [openOnEnter]="true"
            [virtualScroll]="true"
            [clearable]="false"
            (ngModelChange)="filterAssets(); changeQueryParams()"
          >
            <ng-option [value]="-1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "ASSIGN_MALE" | translate }}</span>
            </ng-option>
            <ng-option [value]="1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "YES" | translate }}</span>
            </ng-option>
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
            </ng-option>
          </ng-select>
        </div>
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'col-6 pl-0 mb-1'" [ngClass.sm]="'mb-075'">
          <ng-select [ngClass.xl]="'ml-1 my-width'" [(ngModel)]="filter_rent" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filterAssets(); changeQueryParams()">
            <ng-option [value]="-1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "RENTAL" | translate }}</span>
            </ng-option>
            <ng-option [value]="1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "YES" | translate }}</span>
            </ng-option>
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
            </ng-option>
          </ng-select>
        </div>
        <div [ngClass.xl]="'float-left'" [ngClass.md]="'col-6 pr-0 mb-1'" [ngClass.sm]="'mb-075'">
          <ng-select
            [ngClass.xl]="'ml-1 my-width'"
            [(ngModel)]="filter_maintenance"
            [closeOnSelect]="true"
            [openOnEnter]="true"
            [virtualScroll]="true"
            [clearable]="false"
            (ngModelChange)="filterAssets(); changeQueryParams()"
          >
            <ng-option [value]="-1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "MAINTENANCE" | translate }}</span>
            </ng-option>
            <ng-option [value]="1">
              <span class="font-small-4 font-weight-normal pr-2">{{ "YES" | translate }}</span>
            </ng-option>
            <ng-option [value]="0">
              <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
            </ng-option>
          </ng-select>
        </div>
        <div class="float-right" [ngClass.md]="'d-flex w-100 justify-content-end'">
          <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'" [ngClass.md]="'mr-1'">
            <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
          </div>
          <a class="btn btn-outline-primary text-primary" routerLink="/dashboard/assets/add" has_capability="create_asset">
            {{ "ADD" | translate }}
          </a>
          <button class="btn btn-outline-primary text-primary ml-2" (click)="export()" has_capability="create_asset">
            {{ "EXPORT_EXCEL" | translate }}
          </button>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [rows]="filteredAssets"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 190"
          [limit]="tableLimit"
          [footerHeight]="50"
        >
          <ngx-datatable-column [name]="'BRAND_MODEL' | translate" prop="name" [sortable]="true" [width]="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/assets/detail/' + row.id" *ngIf="_authenticationService.hasCapability('view_asset')">{{ row.name }}</a>
              <span *ngIf="!_authenticationService.hasCapability('view_asset')">{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'INTERNAL_SERIAL' | translate" prop="serial" [sortable]="true" [width]="150" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.serial ? row.serial : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CATEGORY' | translate" prop="category_name" [sortable]="true" [width]="150" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.category_name ? row.category_name : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'EMPLOYEE' | translate" [prop]="'user.complete_name'" [sortable]="true" [width]="windowWidth > 1440 ? 190 : 150" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span *ngIf="!row.user || !row.user.complete_name"> - </span>
              <a *ngIf="row.user && row.user.complete_name" [routerLink]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RENTAL' | translate" prop="rented" [sortable]="true" [width]="windowWidth > 1440 ? 150 : 100" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.rented ? "YES" : "NO") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'MAINTENANCE' | translate" prop="inMaintenance" [sortable]="true" [width]="windowWidth > 1440 ? 150 : 100" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.inMaintenance ? "YES" : "NO") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" [width]="windowWidth > 1440 ? 130 : 100" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div ngbDropdown container="body">
                <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                  <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                </button>
                <div ngbDropdownMenu>
                  <a ngbDropdownItem (click)="showModalAdd(row.id)" *ngIf="row.assigned == false && _authenticationService.hasCapability('manage_assign_asset')"
                    ><span [data-feather]="'plus'" size="16" class="mr-50"></span> {{ "ASSOCIATE" | translate }}</a
                  >
                  <a ngbDropdownItem *ngIf="row.assigned == true && _authenticationService.hasCapability('manage_assign_asset')" (click)="dissociateAsset(row.id)"
                    ><span [data-feather]="'minus'" size="16" class="mr-50"></span> {{ "DISSOCIATE" | translate }}
                  </a>
                  <a ngbDropdownItem [routerLink]="'/dashboard/assets/edit/' + row.id" *ngIf="_authenticationService.hasCapability('edit_asset')">
                    <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                  </a>
                  <a ngbDropdownItem class="text-danger" (click)="deleteAsset(row.id, row.name)" *ngIf="_authenticationService.hasCapability('delete_asset')">
                    <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'BRAND_MODEL' | translate" prop="name" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center">
                    <a [routerLink]="'/dashboard/assets/detail/' + row.id" *ngIf="_authenticationService.hasCapability('view_asset')">{{ row.name }}</a>
                    <span *ngIf="!_authenticationService.hasCapability('view_asset')">{{ row.name }}</span>
                    <div ngbDropdown container="body">
                      <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                        <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                      </button>
                      <div ngbDropdownMenu>
                        <a ngbDropdownItem (click)="showModalAdd(row.id)" *ngIf="row.assigned == false && _authenticationService.hasCapability('manage_assign_asset')">
                          <span [data-feather]="'plus'" size="16" class="mr-50"> </span> {{ "ASSOCIATE" | translate }}</a
                        >
                        <a ngbDropdownItem *ngIf="row.assigned == true && _authenticationService.hasCapability('manage_assign_asset')" (click)="dissociateAsset(row.id)">
                          <span [data-feather]="'minus'" size="16" class="mr-50"> </span> {{ "DISSOCIATE" | translate }}
                        </a>
                        <a ngbDropdownItem [routerLink]="'/dashboard/assets/edit/' + row.id" *ngIf="_authenticationService.hasCapability('edit_asset')">
                          <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                        </a>
                        <a ngbDropdownItem class="text-danger" (click)="deleteAsset(row.id, row.name)" *ngIf="_authenticationService.hasCapability('delete_asset')">
                          <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold mr-025">{{ "INTERNAL_SERIAL" | translate }}:</span>
                    <span>{{ row.serial ? row.serial : "-" }}</span>
                  </div>
                  <div>
                    <span class="font-weight-bold mr-025">{{ "CATEGORY" | translate }}:</span>
                    <span class="font-weight-bold mr-025">{{ row.category_name ? row.category_name : "-" }}</span>
                  </div>
                  <div class="d-flex">
                    <span class="font-weight-bold mr-025">{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}:</span>
                    <a *ngIf="row.user.complete_name" [routerLink]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
                  </div>
                  <div>
                    <span class="font-weight-bold mr-025">{{ "MAINTENANCE" | translate }}</span>
                    <span>{{ (row.inMaintenance ? "YES" : "NO") | translate }}</span>
                  </div>
                  <div>
                    <span class="font-weight-bold mr-025">{{ "RENTAL" | translate }}</span>
                    <span>{{ (row.rented ? "YES" : "NO") | translate }}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
<app-assets-associate-modal
  *ngIf="toggleModalAssociate && _authenticationService.hasCapability('manage_assign_asset')"
  [assetID]="AssetIdSelectedForAssociate"
  (callbackFn)="toggleModalAssociate = false"
  (onAssociate)="onAssociateModalFormEvent()"
></app-assets-associate-modal>
